/**
 * Het Gedenkboekje-woordmerk uit `src/Gedenk.Api/wwwroot/brand/` (lichte variant), via een
 * CSS-masker ingekleurd met een token. Zo blijft het het échte merkasset én de ontwerpkleur.
 */
export function Wordmark({ height = 22 }: { height?: number }) {
  return (
    <span
      role="img"
      aria-label="Gedenkboekje"
      style={{
        display: 'block',
        height,
        width: (height * 1072.16) / 120.44,
        backgroundColor: 'var(--color-mint)',
        maskImage: 'url(/brand/wordmark-cream.svg)',
        WebkitMaskImage: 'url(/brand/wordmark-cream.svg)',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
      }}
    />
  );
}
